module.exports = __webpack_public_path__ + "img/logo_white.6ac0d2df.png";